import React from 'react';
import GoTop from "./goBack/goTop";
export default class FixeButtomBtn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render(){
        const _this = this;
        return (
            <div>
                {
                    _this.props.showFixButton 
                    ?   <div className="homeFixBtnContainer">
                            <button className="btn btn-contact" onClick={ _this.myCource.bind(this) }>我的课程</button>
                            <button className="btn btn-download" onClick={ _this.downLoad.bind(_this) }>下载放射沙龙App</button>
                        </div>
                    : null
                }
                {
                    _this.state.showTopNav
                    ? <GoTop ></GoTop>
                    : null
                }               
           </div>
        );
    }
    componentDidMount() {
        const _this = this;
    }
    myCource(){
        const _this = this;
        _this.props.myCourceHandler();
    }
    downLoad(){
        const _this = this;
        _this.props.downLoadHandler();
    }
}
